<p class="version" [attr.aria-hidden]="hidden" [ngClass]="{ hidden: hidden }">
  {{ product }} version {{ appVersion }}
  <br />
  <span class="revision">revision: {{ version + '-' + revision + (hidden ? '-' + npmVersion : '') }}</span>
</p>
